import { action, observable, makeObservable } from 'mobx';
import axios from 'axios';
import { errorAlert } from '../utils/alerts';
import { successAlert } from 'feller-auth0-portal/src/utils/alerts';

const { REACT_APP_API_URL } = process.env;

class DevicesStore {
  constructor(profileStore) {
    makeObservable(this, {
      devices: observable,
      loadingDevices: observable,
      getUserDevices: action,
      deleteDevice: action,
      resetUserDevices: action
    });

    this.profileStore = profileStore;
  }

  devices = [];

  loadingDevices = false;

  getUserDevices = async userId => {
    const authToken = await this.profileStore.getAuthToken();

    try {
      const { data } = await axios.get(`${REACT_APP_API_URL}/users/devices/${encodeURIComponent(userId)}`, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      this.devices = data;
    } catch (err) {
      this.devices = [];
      this.loadingDevices = false;
    }
  };

  deleteDevice = async (deviceTokenIds, t) => {
    const authToken = await this.profileStore.getAuthToken();

    try {
      await axios.post(
        `${REACT_APP_API_URL}/users/delete-device`,
        { deviceTokenIds },
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      successAlert(t('devicesPage.alert.success'));
    } catch (err) {
      errorAlert(t('devicesPage.alert.error'));
    }
  };

  resetUserDevices = () => {
    this.devices = [];
  };
}

export default DevicesStore;
